import React, { useContext, useEffect, useState } from 'react'
import './SkinAssessmentResult.scss';
import { EXCLUDE_AGE_SUFFIX, NORMAL, SKIN_MAPPER, SKIN_RESULT_USER_DETAILS, USER_DETAILS_MAPPER } from '../../../../../common/skinAssessmentConstant';
import { useDispatch, useSelector } from 'react-redux';
import { addSelectedProductToCart, getAssessmentProducts, getHnWAssessmentHistoryLog, getSkinAssessmentResult, updateAssessmentProducts } from '../../../../../actions';
import LoadingOverlay from 'react-loading-overlay';
import { useHistory, useLocation } from 'react-router-dom';
import { SkinAssessmentFooterContext } from '../../SkinAssessmentFooterContext';
import SkinResultModal from '../../../../../helpers/skinResultModal/SkinResultModal';
import ProductCarousel from '../../../assessment/score/components/ProductCarousel';
import { getCustomerAge } from '../../../../../services/healthWellness/healthWellness.service';
import { getDataFromSession } from '../../../../../utill.func';
import RadarChart from '../../../../shared/graph/RadarChart';
import config from '../../../../../config';
import { Slideup } from '../../../../../common';
import { routesMap } from '../../../../../common/commonConstant';
import { SkinAssessmentHeaderContext } from '../../SkinAssessmentHeaderContext';

const SkinAssessmentResult = ({ routeTo }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const setFooterAction = useContext(SkinAssessmentFooterContext);
    const setHeaderAction = useContext(SkinAssessmentHeaderContext);
    const urlParams = new URLSearchParams(location.search);
    const { skinResult, assessmentHistoryLog, assessmentProducts, customerCart } = useSelector(state => state.assessment);
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [selectedSkinType, setSelectedSkinType] = useState('');
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [graphData, setGraphData] = useState([]);
    const isAnonymous = urlParams.get('isAnonymous') === 'true';

    useEffect(() => {
        try {
            setLoading(true);
            if (setFooterAction) {
                setFooterAction({
                    buttonActive: true,
                    handleSubmit: handleSubmit,
                    handleBack: handleBack,
                    backBtnText: 'กลับสู่หน้าหลัก',
                    nextBtnText: 'ทำแบบประเมิน'
                });
            }
            const customerId = urlParams.get('customer_id') ?? null;
            if (!isAnonymous) {
                dispatch(getHnWAssessmentHistoryLog(urlParams.get('assessment_id'), customerId));
            }
            fetchAssessmentDetails(urlParams.get('answer_id'));
        } catch (e) {
            setLoading(true);
        }
    }, [])

    useEffect(() => {
        try {
            if (selectedOption && selectedOption._id !== urlParams.get('answer_id') && !isAnonymous) {
                urlParams.set('answer_id', selectedOption._id);
                history.replace({ search: urlParams.toString() });
                fetchAssessmentDetails(selectedOption._id);
            }
        } catch (e) {
            setLoading(false);
        }
    }, [selectedOption])

    useEffect(() => {
        const customerId = urlParams.get('customer_id') ?? null;
        if (skinResult?.results) {
            const recommendObj = {}
            skinResult.results.forEach(res => {
                if (!recommendObj[res.key]) {
                    recommendObj[res.key] = [];
                }
                res.scores.forEach(score => {
                    recommendObj[res.key] = [...recommendObj[res.key], ...score.recommended];
                })
            })
            for (const [key, value] of Object.entries(recommendObj)) {
                if (value?.length) {
                    dispatch(getAssessmentProducts(key, value, customerId));
                }
            }
        }
        if (skinResult?.productIds) {
            const singleObject = skinResult?.productIds.reduce((acc, curr) => {
                return { ...acc, ...curr };
            }, {});
            const productIds = [];
            for (const value of Object.values(singleObject)) {
                productIds.push(value);
            }
            dispatch(getAssessmentProducts('recommended', productIds, customerId));
        }
        if (skinResult?.scoreMetadata) {
            const grouped = skinResult?.scoreMetadata.reduce((acc, { key, score, maxScore }) => {
                if (!acc[key]) {
                    acc[key] = { key, score: 0, maxScore: 0 };
                }

                acc[key].score += score;
                acc[key].maxScore += maxScore;
                return acc;
            }, {});

            const graphData = Object.values(grouped).map(item => ({
                label: SKIN_MAPPER[item.key.toLowerCase()] ? SKIN_MAPPER[item.key.toLowerCase()]?.graphlabel : item.key,
                value: item.score,
                maxScore: item.key.toLowerCase() === NORMAL ? SKIN_MAPPER[item.key.toLowerCase()].maxScore : item.maxScore,
                minScore: 0
            }));
            setGraphData(graphData)
        }
    }, [skinResult])

    useEffect(() => {
        if (assessmentProducts?.recommended?.products) {
            const singleObject = skinResult?.productIds.reduce((acc, curr) => {
                return { ...acc, ...curr };
            }, {});
            const reversed = Object.entries(singleObject).reduce((acc, [key, value]) => {
                acc[value.replace(/\D/g, "")] = key;
                return acc;
            }, {});
            assessmentProducts.recommended.products.forEach(product => {
                const id = product.id.replace(/\D/g, "");
                product.skinBadge = SKIN_MAPPER[reversed[id]]?.image ?? '';
            });
            dispatch(updateAssessmentProducts('recommended', assessmentProducts.recommended));
        }
    }, [assessmentProducts?.recommended?.products])

    useEffect(() => {
        if (assessmentHistoryLog && assessmentHistoryLog.length > 1) {
            setSelectedOption(assessmentHistoryLog[0]);
        }
    }, [assessmentHistoryLog])

    const fetchAssessmentDetails = (answerId) => {
        try {
            setLoading(true);
            const customer = getDataFromSession('customer')
            const age = sessionStorage.getItem('skinAssessmentAge');
            const gender = sessionStorage.getItem('skinAssessmentGender');
            let payload = null;
            if (age && gender) {
                payload = {
                    age,
                    gender
                }
            } else if (customer.gender && customer.birthday) {
                payload = {
                    age: `${getCustomerAge(customer)}`,
                    gender: customer.gender
                }
            }
            dispatch(getSkinAssessmentResult(answerId, payload))
                .finally(() => setLoading(false));
        } catch (e) {
            setLoading(false);
        }
    }

    const handleSubmit = () => {
        routeTo(routesMap.skinHome, `?assessment_id=${urlParams.get('assessment_id')}`);
    }
    const handleBack = () => {
        routeTo(routesMap.skinHome, `?assessment_id=${urlParams.get('assessment_id')}`);
    }


    const handleAddProductEvent = async (product) => {
        if (product?.isSelected) {
            return;
        }
        try {
            setLoading(true);
            await dispatch(addSelectedProductToCart(customerCart?.cartId, product))
            setHeaderAction(true);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };

    return (
        <>
            {loading ? (<LoadingOverlay
                text="Loading"
                spinner
                active={loading}
                styles={{ wrapper: { width: '100%', height: '100%', position: 'fixed', top: 0, left: 0, zIndex: 10 } }}
            >
                <div />
            </LoadingOverlay>) : null}
            <div className='result-container'>
                <div className="result-header">
                    {assessmentHistoryLog && assessmentHistoryLog?.length > 1 && !isAnonymous ?
                        <div className="dropdown">
                            <button
                                className="dropdown__header"
                                onClick={() => setOpen(!open)}
                            >
                                <span>{selectedOption?.log_date}</span>
                                <span className={`arrow ${open ? "open" : ""}`} />
                            </button>
                            {open && (
                                <div className="dropdown__list">
                                    {
                                        assessmentHistoryLog?.map((history, index) => (
                                            <div key={`item-${index}`} onClick={() => { setSelectedOption(history); setOpen(!open) }} className="dropdown__item">
                                                {history.log_date}
                                            </div>
                                        ))
                                    }
                                </div>
                            )}
                        </div> : null
                    }
                    <div className="result-header-text">
                        ผลการประเมินสภาพผิว
                        {
                            isAnonymous ?
                                <span className='result-header-text-sub'>(ไม่ระบุตัวตน)</span> : null
                        }
                    </div>
                    {graphData?.length ? <RadarChart data={graphData} width={400} height={400} /> : null}
                </div>
                <div className='result-title'>
                    <div className='result-title-text'>
                        สรุปผลการประเมิน
                    </div>
                </div>
                <div className="result-user">
                    {
                        skinResult?.userInfo?.profileImageUrl ?
                            <div className="image-container">
                                <img src={`${config.S3_URL}${skinResult?.userInfo.profileImageUrl}`} />
                            </div> : null
                    }
                    <div className={`result-user-details ${!skinResult?.userInfo?.profileImageUrl ? 'w-100' : ''}`}>
                        {
                            skinResult?.userInfo && SKIN_RESULT_USER_DETAILS.map(((el, index) => (
                                <div className='result-user-details-label' key={`detail-${index}`}>
                                    {el.label}:
                                    {USER_DETAILS_MAPPER[`${skinResult.userInfo[el.value]}`?.toUpperCase()]
                                        ? ` ${USER_DETAILS_MAPPER[skinResult.userInfo[el.value]?.toUpperCase()]}`
                                        : ` ${skinResult.userInfo[el.value]}`} {!EXCLUDE_AGE_SUFFIX.includes(skinResult.userInfo[el.value]) ? el.suffix : ''}
                                </div>
                            )))
                        }
                    </div>
                </div>
                <div className='result-title'>
                    <span className='result-title-text'>
                        สินค้าไฮไลท์
                    </span>
                    <span className='result-title-sub'>(สินค้าแนะนำสำหรับแต่ละปัญหา)</span>
                </div>
                {assessmentProducts?.recommended?.products && (
                    <ProductCarousel
                        data={assessmentProducts?.recommended?.products}
                        handleAddProductEvent={(product) => {
                            handleAddProductEvent(product);
                        }}
                    />
                )}
                {
                    skinResult?.results.map((result, resIdx) => (
                        <div key={`${result.key}-${resIdx}`} className='result-skin-type-card'>
                            <div className={`result-skin-type-title ${SKIN_MAPPER[result.key]?.image}`}>
                                {SKIN_MAPPER[result.key].label}
                                <div className="result-skin-type-image-container">
                                    <img className={`skin-type-image ${SKIN_MAPPER[result.key]?.image}`} src={`/images/skin-assessment/${SKIN_MAPPER[result.key]?.image}.svg`} />
                                </div>
                            </div>
                            {
                                result?.scores.map((score, sIdx) => (
                                    <div key={`${result.key}-score-${sIdx}`} className={`result-skin-desc-container ${SKIN_MAPPER[result.key]?.image}`}>
                                        {
                                            score?.descriptions.map((desc, descIdx) => (
                                                <div key={`${result.key}-desc-${descIdx}`} className="result-skin-desc">
                                                    <span>{desc.short}</span>
                                                    <span onClick={() => { setSelectedSkinType(result.key); setModalContent(desc); setIsModal(true); }} className="info">i</span>
                                                </div>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                            <div className={`skin-recommendation ${SKIN_MAPPER[result.key]?.image}`}>
                                {SKIN_MAPPER[result.key].recommendLabel}
                            </div>
                            {assessmentProducts?.[result.key]?.products && (
                                <ProductCarousel
                                    data={assessmentProducts?.[result.key]?.products}
                                    handleAddProductEvent={(product) => {
                                        handleAddProductEvent(product);
                                    }}
                                    skinBadge={SKIN_MAPPER[result.key]?.image}
                                />
                            )}
                        </div>
                    ))
                }
                <Slideup bottomGap={'10%'} customClass='skin-result-slide-up' />
            </div >
            {
                selectedSkinType ?
                    <SkinResultModal open={isModal} onClose={() => setIsModal(!isModal)} content={modalContent}
                        customClass={SKIN_MAPPER[selectedSkinType].image} /> : null
            }
        </>
    )
}

export default SkinAssessmentResult
